import React from "react";
import { IField } from "../../shared/interfaces";
import { Label } from "@fluentui/react";


export interface ArxeiaLabelProps {
    field: IField
}

const ArxeiaLabel: React.FunctionComponent<ArxeiaLabelProps> = props => {
    if (props.field.customLabel) {
        return <React.Fragment>{props.field.customLabel}</React.Fragment>;
    }
    else {
        return <Label className='field-label' htmlFor={props.field.internalName} required={props.field.required}>{props.field.displayName}</Label>
    }
}
export default ArxeiaLabel;
